module.exports = __webpack_public_path__ + "img/1f635.bd56d22.svg";